import { createGlobalStyle, css } from 'styled-components';
import {
  standardColours,
  greyColours,
  brandColours,
  brandFonts,
  fontSize,
  zIndexLayers,
  maxBreakpointQuery,
} from '../styles';
import gustolleWoff2 from '../fonts/gustolle.woff2';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Gustolle';
    src: url('${gustolleWoff2}') format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  html {
    box-sizing: border-box;
    font-size: 62.5%;
    -webkit-font-smoothing: antialiased;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;

    ${({isCheckout}) => {
      if(!isCheckout) {
        return css`
          scroll-behavior: smooth;
        `
      }
    }}
  }

  body {
    position: relative;
    margin: 0;
    padding: 0;
    color: ${({ altTheme }) =>
      altTheme ? standardColours.white : brandColours.primary};
    ${brandFonts.primary};
    ${fontSize(16)}
    line-height: 1.3;
    background-color: ${({ altTheme }) =>
      altTheme ? brandColours.nonary : standardColours.white};

    ${({ isOverlayActive }) => {
      if (isOverlayActive) {
        return css`
          overflow: hidden;

          &:before {
            content: '';
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: ${zIndexLayers.sixth};
            background-color: ${standardColours.black};
            opacity: 0.65;
          }
        `;
      }
    }}
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
  }

  ul,
  ol {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
  
  img {
    height: auto;
    width: auto;
    vertical-align: middle;
    max-width: 100%;
    border: 0;
    -ms-interpolation-mode: bicubic;
  }

  fieldset {
    margin: 0;
    padding: 0;
    border: none;
  }

  legend {
    padding: 0;
  }

  button,
  input,
  select,
  textarea {
    color: ${brandColours.primary};
    ${brandFonts.primary};
    ${fontSize(16)};
    line-height: 1.3;
    border-radius: 0;
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
  }

  input {

    ::-webkit-input-placeholder {
      color: ${greyColours.darkPurplishGrey};
    }

    ::-moz-placeholder {
      color: ${greyColours.darkPurplishGrey};
    }

    :-ms-input-placeholder {
      color: ${greyColours.darkPurplishGrey};
    }

    :-moz-placeholder {
      color: ${greyColours.darkPurplishGrey};
    }
  }

  select {

    option {

      &:first-child {
        color: ${greyColours.darkPurplishGrey};
      }
    }
  }

  textarea {
    width: 100%;
    resize: vertical;
  }

  table.table {
    width: 75%;
    margin-bottom: 2rem;

    ${maxBreakpointQuery.tsmall`
      width: 100%;
    `}

    th, td {
      text-align: center;
    }
  }

  // For Trustpilot test
  .trustpilot-widget-test {
    display: none;
  }
`;

export default GlobalStyle;
